import { QuoteException } from '@/domain/stripe/quote/exception/QuoteException'

export class CouldNotSaveQuoteInfoException extends QuoteException {

}